import { useLocation } from 'react-router-dom';
const useIsPublicUrl = () => {
  const {
    pathname
  } = useLocation();
  return pathname.includes('achievements');
};
export default useIsPublicUrl;